export default __webpack_public_path__ + "static/home-asider-bc2468d746942c8aff96608fbab8abc8.png";